import gql from 'graphql-tag';

import {OLD_MODEL_REGISTRY_PROJECT_NAME} from '../../../util/artifacts';

export const projectsFragment = gql`
  fragment ProjectFragment on Project {
    internalId
    name
    user {
      id
      name
      photoUrl
    }
    entityName
    access
    createdAt
    lastActive
    updatedAt
    description
    totalArtifactCollections(collectionTypes: [PORTFOLIO])
    artifactTypes(includeAll: true) {
      edges {
        node {
          id
          name
        }
      }
    }
    allowAllArtifactTypesInRegistry
    protectedArtifactAliases {
      alias
    }
    icon {
      name
      color
    }
  }
`;

export const registryProjectsSearchFragment = gql`
  fragment RegistryProjectsSearchFragment on ProjectConnection {
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        ...ProjectFragment
      }
    }
  }
  ${projectsFragment}
`;

export const FETCH_REGISTRY_PROJECTS_PARTIAL = gql`
  query FetchRegistryProjectsPartial(
    $orgName: String!
    $pattern: String
    $after: String
    $filters: JSONString
    $order: String
    $limit: Int
  ) {
    organization(name: $orgName) {
      id
      registries(
        pattern: $pattern
        filters: $filters
        order: $order
        after: $after
        first: $limit
      ) {
        ...RegistryProjectsSearchFragment
      }
    }
  }
  ${registryProjectsSearchFragment}
`;

export const LEGACY_REGISTRY_PROJECTS_QUERY = gql`
  query LegacyRegistryProjects($entityName: String!) {
    projects(pattern: "${OLD_MODEL_REGISTRY_PROJECT_NAME}", entityName: $entityName) {
      edges {
        node {
          id
          ...ProjectFragment
        }
      }
    }
  }
  ${projectsFragment}
`;

export const REGISTRY_PROJECTS_WITH_TYPE_QUERY = gql`
  query RegistryProjectsWithType(
    $orgName: String!
    $artifactTypeName: String!
  ) {
    organization(name: $orgName) {
      id
      registries(pattern: "wandb-registry-") {
        edges {
          node {
            id
            name
            artifactType(name: $artifactTypeName) {
              id
              name
            }
            allowAllArtifactTypesInRegistry
            entityName
          }
        }
      }
    }
  }
  ${projectsFragment}
`;

export const REGISTRY_PROJECT_UPSERT = gql`
  mutation upsertRegistryProject(
    $description: String
    $entityName: String
    $id: String
    $name: String
    $access: String
    $owner: ID
    $allowAllArtifactTypesInRegistry: Boolean
    $artifactTypes: [ArtifactTypeInput!]
    $icon: ProjectIconInput
  ) {
    upsertModel(
      input: {
        description: $description
        entityName: $entityName
        id: $id
        name: $name
        access: $access
        owner: $owner
        allowAllArtifactTypesInRegistry: $allowAllArtifactTypesInRegistry
        artifactTypes: $artifactTypes
        icon: $icon
      }
    ) {
      project {
        id
        name
        entityName
        description
        access
        user {
          id
        }
        allowAllArtifactTypesInRegistry
        icon {
          name
          color
        }
      }
      inserted
    }
  }
`;

export const REGISTRY_PROJECT_QUERY = gql`
  query RegistryProject($orgName: String!, $projectName: String!) {
    organization(name: $orgName) {
      id
      orgEntity {
        id
        name
        project(name: $projectName) {
          id
          ...ProjectFragment
        }
      }
    }
  }
  ${projectsFragment}
`;

export const STARRED_REGISTRIES_QUERY = gql`
  query StarredRegistries($organizationId: ID) {
    viewer {
      id
      starredRegistries(first: 30, organizationID: $organizationId) {
        edges {
          node {
            id
            ...ProjectFragment
          }
        }
      }
    }
  }
  ${projectsFragment}
`;
